module.exports = __webpack_public_path__ + "static/media/Price_Tags_IMG-Mobile.74c24e54.png";